import { createFileRoute } from "@tanstack/react-router";
import { LegalPage } from "@/components/legal-page";

export const Route = createFileRoute("/contact")({
  head: () => ({
    meta: [
      { title: "Contact DeckScore - Help Getting Investor-Ready" },
      {
        name: "description",
        content:
          "Questions about scoring your deck or reaching investors? Contact the DeckScore team - we help first-time founders get investor-ready and in front of VCs.",
      },
      { property: "og:title", content: "Contact DeckScore - Help Getting Investor-Ready" },
      {
        property: "og:description",
        content:
          "Questions about scoring your deck or reaching investors? Contact the DeckScore team - we help first-time founders get investor-ready and in front of VCs.",
      },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "https://deckscore.ai/contact" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
    links: [{ rel: "canonical", href: "https://deckscore.ai/contact" }],
  }),
  component: ContactPage,
});

function ContactPage() {
  return (
    <LegalPage title="Contact Us">
      <p>
        We'd love to hear from you. For any questions about DeckScore, our services, billing, refunds, or your data, reach out to us:
      </p>
      <ul>
        <li><strong>Company:</strong> Adviselo Collab Studios Private Limited</li>
        <li><strong>Email:</strong> <a href="mailto:info@ikomatch.com">info@ikomatch.com</a></li>
        <li><strong>Phone:</strong> <a href="tel:+919723461686">+91 9723461686</a></li>
        <li><strong>Address:</strong> Surat, Gujarat, India</li>
      </ul>
      <p>We typically respond within 24-48 hours.</p>
    </LegalPage>
  );
}
